(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aureole-reveal"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=section=>{if(!section||section.dataset.ready)return;section.dataset.ready='true';const range=section.querySelector('input');const stage=section.querySelector('.au-reveal-stage');const button=section.querySelector('[data-au-toggle]');const startLabel=button.textContent;const update=()=>{stage.style.setProperty('--au-split',range.value+'%');range.setAttribute('aria-valuetext',range.value+'% light on');button.textContent=Number(range.value)===100?button.dataset.offLabel:startLabel};range.addEventListener('input',update);button.addEventListener('click',()=>{range.value=Number(range.value)===100?'0':'100';update()});update()};document.querySelectorAll('.au-reveal').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('.au-reveal')));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinu-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kinu-story')) {
    customElements.define('kinu-story', class extends HTMLElement {
      connectedCallback() {
        if (this.kinuConnected) return;
        this.kinuConnected = true;
        this.kinuAbort = new AbortController();
        const options = { signal: this.kinuAbort.signal };
        this.kinuTabs = Array.from(this.querySelectorAll('[data-kinu-tab]'));
        this.kinuTabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.kinuSelectStep(tab.dataset.kinuTab), options);
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.kinuTabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.kinuTabs.length) % this.kinuTabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.kinuTabs.length - 1;
            else return;
            event.preventDefault();
            this.kinuTabs[next].focus();
            this.kinuSelectStep(this.kinuTabs[next].dataset.kinuTab);
          }, options);
        });
        this.querySelectorAll('[data-kinu-comparison-range]').forEach(range => {
          range.addEventListener('input', () => range.closest('[data-kinu-comparison]').style.setProperty('--kinu-reveal', `${range.value}%`), options);
        });
        document.addEventListener('kinu:selection', event => this.kinuSetContents(event.detail), options);
        document.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-kinu-panel]');
          if (panel && this.contains(panel)) this.kinuSelectStep(panel.dataset.kinuPanel);
        }, options);
        document.dispatchEvent(new CustomEvent('kinu:story-ready', { detail: { section: this } }));
      }
      disconnectedCallback() {
        this.kinuAbort?.abort();
        this.kinuConnected = false;
      }
      kinuSelectStep(id) {
        this.kinuTabs.forEach(tab => {
          const active = tab.dataset.kinuTab === id;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.querySelectorAll('[data-kinu-panel]').forEach(panel => { panel.hidden = panel.dataset.kinuPanel !== id; });
      }
      kinuSetContents(detail) {
        if (!detail || !Array.isArray(detail.items)) return;
        const title = this.querySelector('[data-kinu-contents-title]');
        const list = this.querySelector('[data-kinu-contents-list]');
        if (!title || !list) return;
        if (typeof detail.title === 'string') title.textContent = detail.title;
        const items = detail.items.filter(item => typeof item === 'string' || item && typeof item.title === 'string');
        list.replaceChildren(...items.map(item => {
          const li = document.createElement('li');
          if (typeof item === 'string') li.textContent = item;
          else {
            const quantity = Number.isFinite(Number(item.quantity)) && Number(item.quantity) > 0 ? Number(item.quantity) : 1;
            li.textContent = `${quantity} × ${item.title}${item.size ? ` · ${item.size}` : ''}`;
          }
          return li;
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reframe-essentials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      const sections = scope.matches && scope.matches('.rf-essentials') ? [scope] : scope.querySelectorAll('.rf-essentials');
      sections.forEach((section) => {
        if (section.dataset.rfEssentialsReady) return;
        section.dataset.rfEssentialsReady = 'true';
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.dataset.rfEssentialsReveal = 'visible';
            observer.unobserve(entry.target);
          });
        }, { threshold: .08 });
        section.querySelectorAll('[data-rf-essentials-reveal]').forEach((element) => {
          if (element.getBoundingClientRect().top > window.innerHeight) element.dataset.rfEssentialsReveal = 'pending';
          observer.observe(element);
        });
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reframe-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{if(event.target.closest('.rf-nav-bag')){const drawer=document.querySelector('cart-drawer');if(drawer?.open)drawer.open(event.target);else location.href=window.routes?.cart_url||'/cart'}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reframe-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      const sections = scope.matches && scope.matches('.rf-story') ? [scope] : scope.querySelectorAll('.rf-story');
      sections.forEach((section) => {
        if (section.dataset.rfStoryReady) return;
        section.dataset.rfStoryReady = 'true';
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.dataset.rfStoryReveal = 'visible';
            observer.unobserve(entry.target);
          });
        }, { threshold: .08 });
        section.querySelectorAll('[data-rf-story-reveal]').forEach((element) => {
          if (element.getBoundingClientRect().top > window.innerHeight) element.dataset.rfStoryReveal = 'pending';
          observer.observe(element);
        });
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reframe-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reframe-studio')) {
    customElements.define('reframe-studio', class extends HTMLElement {
      connectedCallback() {
        this.connect = () => this.initialize();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.connect, { once: true });
        else this.initialize();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.connect);
        this.events?.abort();
        this.cancelRefresh();
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
        this.initialized = false;
      }
      initialize() {
        if (this.initialized) return;
        this.canvas = this.querySelector('[data-preview]');
        if (!this.canvas) return;
        this.context = this.canvas.getContext('2d', { willReadFrequently: true });
        if (!this.context) return;
        this.initialized = true;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.mode = 'reminder';
        this.tabs = [...this.querySelectorAll('[data-mode]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.status = this.querySelector('[data-status]');
        this.error = this.querySelector('[data-error]');
        this.refreshButton = this.querySelector('[data-refresh]');
        this.reminder = this.querySelector('[data-reminder]');
        this.initials = this.querySelector('[data-initials]');
        this.file = this.querySelector('[data-file]');
        this.zoom = this.querySelector('[data-zoom]');
        this.position = this.querySelector('[data-position]');
        this.crop = this.querySelector('[data-crop]');
        this.palette = [[29,30,28], [239,235,220], [166,49,48], [213,173,65]];
        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => this.changeMode(tab.dataset.mode), options);
          tab.addEventListener('keydown', event => {
            const current = this.tabs.indexOf(tab);
            let next = current;
            if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (current + this.tabs.length - 1) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.tabs[next].focus();
            this.changeMode(this.tabs[next].dataset.mode);
          }, options);
        });
        [this.reminder, this.initials, this.zoom, this.position].forEach(input => {
          input.addEventListener('input', () => {
            this.clearError();
            this.status.textContent = this.dataset.ready;
          }, options);
        });
        this.file.addEventListener('change', () => this.loadPhoto(), options);
        this.refreshButton.addEventListener('click', () => this.refresh(true), options);
        this.draw();
      }
      changeMode(mode) {
        this.cancelRefresh();
        this.mode = mode;
        this.clearError();
        this.tabs.forEach(tab => {
          const selected = tab.dataset.mode === mode;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== mode; });
        this.draw();
        this.status.textContent = mode === 'photo' && !this.photo ? this.dataset.choosePhoto : this.dataset.updated;
      }
      clearError() {
        this.error.hidden = true;
        this.error.textContent = '';
        [this.file, this.reminder, this.initials].forEach(input => input.removeAttribute('aria-invalid'));
      }
      showError(message, input) {
        this.error.hidden = false;
        this.error.textContent = message;
        if (input) input.setAttribute('aria-invalid', 'true');
        this.status.textContent = '';
      }
      loadPhoto() {
        this.clearError();
        const file = this.file.files?.[0];
        if (!file) return;
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
          this.showError(this.dataset.invalidType, this.file);
          return;
        }
        if (file.size > 10 * 1024 * 1024) {
          this.showError(this.dataset.tooLarge, this.file);
          return;
        }
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        const objectUrl = URL.createObjectURL(file);
        this.objectUrl = objectUrl;
        const photo = new Image();
        photo.onload = () => {
          if (this.objectUrl !== objectUrl || !this.isConnected) return;
          if (!photo.naturalWidth || !photo.naturalHeight || photo.naturalWidth * photo.naturalHeight > 50000000) {
            this.showError(this.dataset.invalidImage, this.file);
            URL.revokeObjectURL(objectUrl);
            this.objectUrl = null;
            return;
          }
          this.photo = photo;
          this.zoom.value = '1';
          this.position.value = '50';
          this.crop.hidden = false;
          this.refresh(false);
          URL.revokeObjectURL(objectUrl);
          this.objectUrl = null;
        };
        photo.onerror = () => {
          if (this.objectUrl !== objectUrl) return;
          this.showError(this.dataset.invalidImage, this.file);
          URL.revokeObjectURL(objectUrl);
          this.objectUrl = null;
        };
        photo.src = objectUrl;
      }
      cancelRefresh() {
        if (this.refreshTimer) clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
        if (this.refreshButton) this.refreshButton.disabled = false;
        if (this.canvas) this.canvas.removeAttribute('aria-busy');
      }
      refresh(animate) {
        this.cancelRefresh();
        this.clearError();
        if (this.mode === 'photo' && !this.photo) {
          this.showError(this.dataset.choosePhoto, this.file);
          this.file.focus();
          return;
        }
        const input = this.mode === 'monogram' ? this.initials : this.reminder;
        if (this.mode !== 'photo' && !input.value.trim()) {
          this.showError(this.dataset.emptyText, input);
          input.focus();
          return;
        }
        const finish = () => {
          if (!this.isConnected) return;
          this.draw();
          this.refreshButton.disabled = false;
          this.canvas.removeAttribute('aria-busy');
          this.status.textContent = this.dataset.updated;
          this.refreshTimer = null;
        };
        if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          finish();
          return;
        }
        this.refreshButton.disabled = true;
        this.canvas.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.refreshing;
        const shades = ['#dedaca', '#c8c6b7', '#efebdc'];
        let step = 0;
        const blink = () => {
          this.context.fillStyle = shades[step];
          this.context.fillRect(0, 0, 240, 416);
          step += 1;
          this.refreshTimer = setTimeout(step < shades.length ? blink : finish, 140);
        };
        blink();
      }
      wrapText(context, value, size) {
        context.font = `600 ${size}px Georgia, serif`;
        const lines = [];
        value.split(/\r?\n/).forEach(paragraph => {
          let line = '';
          paragraph.split(/\s+/).filter(Boolean).forEach(word => {
            if (context.measureText(word).width > 188) {
              if (line) { lines.push(line); line = ''; }
              Array.from(word).forEach(letter => {
                if (context.measureText(line + letter).width > 188 && line) { lines.push(line); line = letter; }
                else line += letter;
              });
            } else if (line && context.measureText(`${line} ${word}`).width > 188) {
              lines.push(line);
              line = word;
            } else line = line ? `${line} ${word}` : word;
          });
          if (line) lines.push(line);
        });
        return lines;
      }
      draw() {
        const context = this.context;
        context.clearRect(0, 0, 240, 416);
        context.fillStyle = '#efebdc';
        context.fillRect(0, 0, 240, 416);
        if (this.mode === 'photo' && this.photo) {
          const zoom = Number(this.zoom.value);
          const fit = Math.max(240 / this.photo.naturalWidth, 416 / this.photo.naturalHeight) * zoom;
          const width = this.photo.naturalWidth * fit;
          const height = this.photo.naturalHeight * fit;
          const position = Number(this.position.value) / 100;
          const x = width > 240 ? -(width - 240) * position : 0;
          const y = height > 416 ? -(height - 416) * position : 0;
          context.drawImage(this.photo, x, y, width, height);
        } else if (this.mode === 'photo') {
          context.fillStyle = '#d5ad41';
          context.beginPath(); context.arc(120, 147, 39, 0, Math.PI * 2); context.fill();
          context.fillStyle = '#a63130';
          context.beginPath(); context.moveTo(0, 322); context.quadraticCurveTo(98, 149, 240, 299); context.lineTo(240, 416); context.lineTo(0, 416); context.fill();
          context.fillStyle = '#1d1e1c';
          context.beginPath(); context.moveTo(0, 366); context.quadraticCurveTo(144, 232, 240, 369); context.lineTo(240, 416); context.lineTo(0, 416); context.fill();
        } else {
          context.fillStyle = '#d5ad41';
          context.beginPath(); context.arc(120, 94, this.mode === 'monogram' ? 31 : 24, 0, Math.PI * 2); context.fill();
          context.fillStyle = '#1d1e1c';
          context.textAlign = 'center';
          context.textBaseline = 'middle';
          if (this.mode === 'monogram') {
            const value = this.initials.value.trim().toLocaleUpperCase();
            let size = 91;
            context.font = `500 ${size}px Georgia, serif`;
            while (context.measureText(value).width > 196 && size > 36) { size -= 2; context.font = `500 ${size}px Georgia, serif`; }
            context.fillText(value, 120, 227);
          } else {
            const value = this.reminder.value.trim();
            let size = 35;
            let lines = this.wrapText(context, value, size);
            while (lines.length * size * 1.17 > 174 && size > 19) { size -= 1; lines = this.wrapText(context, value, size); }
            const lineHeight = size * 1.17;
            const top = 222 - (lines.length - 1) * lineHeight / 2;
            lines.forEach((line, index) => context.fillText(line, 120, top + index * lineHeight));
          }
          context.fillStyle = '#a63130';
          context.fillRect(99, 337, 42, 3);
          context.fillStyle = '#1d1e1c';
          context.font = '10px -apple-system, BlinkMacSystemFont, sans-serif';
          context.fillText(this.mode === 'monogram' ? this.dataset.canvasMonogram : this.dataset.canvasReminder, 120, 371);
        }
        this.quantize();
      }
      quantize() {
        const image = this.context.getImageData(0, 0, 240, 416);
        const pixels = image.data;
        const work = new Float32Array(pixels.length);
        for (let i = 0; i < pixels.length; i += 1) work[i] = pixels[i];
        for (let y = 0; y < 416; y += 1) {
          for (let x = 0; x < 240; x += 1) {
            const index = (y * 240 + x) * 4;
            const original = [work[index], work[index + 1], work[index + 2]];
            let nearest = this.palette[0];
            let distance = Infinity;
            this.palette.forEach(color => {
              const value = (original[0] - color[0]) ** 2 * .3 + (original[1] - color[1]) ** 2 * .59 + (original[2] - color[2]) ** 2 * .11;
              if (value < distance) { distance = value; nearest = color; }
            });
            for (let channel = 0; channel < 3; channel += 1) {
              pixels[index + channel] = nearest[channel];
              const error = (original[channel] - nearest[channel]) * .75;
              if (x + 1 < 240) work[index + 4 + channel] += error * 7 / 16;
              if (y + 1 < 416) {
                if (x > 0) work[index + 956 + channel] += error * 3 / 16;
                work[index + 960 + channel] += error * 5 / 16;
                if (x + 1 < 240) work[index + 964 + channel] += error / 16;
              }
            }
            pixels[index + 3] = 255;
          }
        }
        this.context.putImageData(image, 0, 0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-header"] && !Shopify.designMode) return;
  try {
    
(()=>{
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
function enter(el){if(!reduced.matches&&el&&el.animate)el.animate([{opacity:.7,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:420,easing:'cubic-bezier(.16,1,.3,1)'});}
function init(root=document){
 root.querySelectorAll('[data-rg-cart]:not([data-rg-ready])').forEach(a=>{a.dataset.rgReady='true';a.addEventListener('click',e=>{const drawer=document.querySelector('cart-drawer');if(drawer&&typeof drawer.open==='function'){e.preventDefault();drawer.open(a);}});});
 root.querySelectorAll('[data-rg-gallery]:not([data-rg-ready])').forEach(g=>{g.dataset.rgReady='true';const slides=[...g.querySelectorAll('[data-rg-slide]')],thumbs=[...g.querySelectorAll('[data-rg-thumb]')];function show(id){slides.forEach(s=>{s.hidden=s.dataset.rgSlide!==id;if(!s.hidden){const t=s.querySelector('template');if(t){t.replaceWith(t.content.cloneNode(true));}enter(s);}});thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.rgThumb===id)));}thumbs.forEach(t=>t.addEventListener('click',()=>show(t.dataset.rgThumb)));g.addEventListener('shopify:block:select',e=>{const s=e.target.closest('[data-rg-slide]');if(s)show(s.dataset.rgSlide);});});
 root.querySelectorAll('[data-rg-product]:not([data-rg-ready])').forEach(p=>{p.dataset.rgReady='true';const data=JSON.parse(p.querySelector('[data-rg-data]').textContent),quantity=p.querySelector('[data-rg-quantity]'),variant=p.querySelector('[name="id"]'),submit=p.querySelector('[name="add"]');const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:data.currency});function update(){const v=data.variants.find(x=>String(x.id)===variant.value);if(!v)return;const q=Number(quantity.value)||1;p.querySelector('[data-rg-price]').textContent=money.format(v.price/100)+' '+data.currency;const c=p.querySelector('[data-rg-compare]'),s=p.querySelector('[data-rg-saving]');c.hidden=s.hidden=!(v.compare_at_price>v.price);c.textContent=money.format((v.compare_at_price||0)/100);s.textContent=data.save+' '+money.format(((v.compare_at_price||0)-v.price)/100);p.querySelector('[data-rg-total]').textContent=money.format(v.price*q/100);p.querySelector('[data-rg-sticky-price]').textContent=money.format(v.price/100);submit.disabled=!v.available;submit.querySelector('.main-atc__label__text').textContent=v.available?data.cta:data.soldOut;}
 variant.addEventListener('change',update);const sticky=p.querySelector('[data-rg-sticky]');if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{const e=entries[0];sticky.hidden=e.isIntersecting||e.boundingClientRect.bottom>0;});observer.observe(p);p._rgObserver=observer;}});
 if('IntersectionObserver'in window&&!reduced.matches){root.querySelectorAll('.rg-club-image:not([data-rg-motion]),.rg-roll-photo:not([data-rg-motion])').forEach(el=>{el.dataset.rgMotion='true';const io=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){el.animate([{clipPath:'inset(0 3% 0 3%)'},{clipPath:'inset(0 0% 0 0%)'}],{duration:800,easing:'cubic-bezier(.16,1,.3,1)'});io.disconnect();}},{threshold:.15});io.observe(el);});}
}
function policy(){const id=location.hash.slice(1);if(!id.startsWith('rg-policy-')&&id!=='rg-contact')return;const el=document.getElementById(id);if(el&&el.tagName==='DETAILS')el.open=true;}
document.addEventListener('click',e=>{const a=e.target.closest('a[href^="#rg-policy-"],a[href="#rg-contact"]');if(a){const panel=document.querySelector(a.getAttribute('href'));if(panel)panel.open=true;}});
document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('[data-rg-product]').forEach(p=>p._rgObserver?.disconnect());});document.addEventListener('shopify:block:select',e=>{const detail=e.target.closest('.rg details');if(detail)detail.open=true;});window.addEventListener('hashchange',policy);init();policy();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-product"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(root){
  if(!root||root.dataset.rgShipInit)return;root.dataset.rgShipInit='1';
  const ship=root;
   const skip=ship.dataset.skipWeekends==='true',loc=ship.dataset.locale||undefined;
   const addDays=n=>{const d=new Date();d.setHours(12,0,0,0);let i=0;while(i<n){d.setDate(d.getDate()+1);if(skip&&(d.getDay()===0||d.getDay()===6))continue;i++}return d};
   const long=d=>d.toLocaleDateString(loc,{weekday:'short',month:'short',day:'numeric'}),short=d=>d.toLocaleDateString(loc,{month:'short',day:'numeric'});
   const shipD=addDays(Number(ship.dataset.shipDays)||0),delD=addDays(Number(ship.dataset.deliverDays)||7);
   ship.querySelectorAll('[data-rg-date="ship"]').forEach(el=>el.textContent=short(shipD));
   ship.querySelectorAll('[data-rg-date="deliver"]').forEach(el=>el.textContent=long(delD));
   ship.querySelectorAll('[data-rg-date="deliver-short"]').forEach(el=>el.textContent=short(delD));
   const locEl=ship.querySelector('[data-rg-loc]');
   if(locEl&&ship.dataset.geo==='true'){
    const apply=g=>{const place=[g.city,g.country].filter(Boolean).join(', ');if(place)locEl.textContent=place;locEl.classList.remove('is-loading')};
    let cached=null;try{cached=JSON.parse(sessionStorage.getItem('rg-geo')||'null')}catch(e){}
    if(cached)apply(cached);else{
     locEl.classList.add('is-loading');
     fetch('https://get.geojs.io/v1/ip/geo.json').then(r=>r.json()).then(d=>{const g={city:d.city||'',country:d.country||''};try{sessionStorage.setItem('rg-geo',JSON.stringify(g))}catch(e){}apply(g)}).catch(()=>locEl.classList.remove('is-loading'));
    }
   }

 }
 const all=()=>document.querySelectorAll('[data-rg-ship]').forEach(init);
 all();document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();
})();
